module.exports = __webpack_public_path__ + "static/media/amr.2.9795c25a.jpeg";